// @ts-nocheck
import { put, takeLatest } from 'redux-saga/effects';
import { postAPIDataV3, putAPIDataV3 } from 'utils/api';
import {
	triggerAddOperation,
	triggerCreateRole,
	triggerRemoveOperation,
	triggeRemovebulkAccess,
	triggerToggleRoleState,
} from './sagaActions';
import { toggleLoader } from 'models/loaders/sagaActions';
import { LOADER_COMPONENTS, TABLE_ID } from './constants';
import { getDispatch } from 'reducers';
import { triggerFetchAutoComplete } from 'models/autoComplete/sagaActions';
import { triggerNotification } from 'organisms/notifications/sagaActions';
import { Events } from 'molecules/ReactGrid/agGrid/utils/events';
import { GRID_EVENTS } from 'molecules/ReactGrid/agGrid/constants';
import { operationsList } from 'models/user/sagaActions';

export const handleCreateRole = async ({ payload: { roleName, componentId } }) => {
	const dispatch = getDispatch();

	try {
		if (!roleName) {
			return;
		}
		dispatch(
			toggleLoader({
				componentId: LOADER_COMPONENTS.CREATE_ROLE,
				isLoading: true,
			})
		);
		const { data } = await postAPIDataV3({
			service: 'acl',
			url: 'roles',
			body: {
				RoleName: roleName,
			},
		});
		dispatch(
			toggleLoader({
				componentId: LOADER_COMPONENTS.CREATE_ROLE,
				isLoading: false,
			})
		);
		dispatch(
			triggerNotification({
				type: 'success',
				message: `Role: ${roleName} has been created successfully`,
			})
		);
		// Events.publish(GRID_EVENTS.CLEAR_SELECTION, { tableId: TABLE_ID})
	} catch (e) {
		console.log(e);
		dispatch(
			triggerNotification({
				type: 'error',
				autoClose: 500,
				message: e?.data?.message ?? `Unable to Add Permission, Please try again later.`,
			})
		);
	}
};

export const handleToggleRoleState = async ({ payload: { roleId, componentId, isActive } }) => {
	const dispatch = getDispatch();
	try {
		try {
			await putAPIDataV3({
				service: 'acl',
				url: `roles/state/${roleId}`,
				body: { IsActive: isActive, IsForced: true },
			});
			dispatch(
				triggerFetchAutoComplete({
					componentId,
				})
			);
			dispatch(
				triggerFetchAutoComplete({
					componentId,
				})
			);
			dispatch(
				triggerNotification({
					type: 'success',
					message: `Role been deleted successfully.`,
				})
			);
		} catch (e) {
			dispatch(
				triggerNotification({
					type: 'success',
					message: `Unable to Delete Role, Please try again later.`,
				})
			);
			console.log(e);
		}
	} catch (e) {
		console.log(e);
	}
};

export const handleAddOperation = async ({ payload: { roleId, operations } }) => {
	const dispatch = getDispatch();
	try {
		const response = await putAPIDataV3({
			service: 'acl',
			url: `roles/${roleId}`,
			body: {
				Operations: operations,
			},
		});
		dispatch(
			triggerNotification({
				type: response?.status === 200 ? 'success' : 'error',
				autoClose: response?.status === 200 ? 100 : 500,
				message: response?.data?.message ?? `Permission Successfully Added`,
			})
		);
		dispatch(operationsList());
		// Events.publish(GRID_EVENTS.CLEAR_SELECTION, { tableId })

		return response;
	} catch (e) {
		dispatch(
			triggerNotification({
				type: 'error',
				autoClose: 500,
				message: e?.data?.message ?? `Unable to Add Permission, Please try again later.`,
			})
		);
		return e;
	}
};

export const handleRemoveOperation = async ({ payload: { roleId, operations } }) => {
	const dispatch = getDispatch();
	try {
		const response = await putAPIDataV3({
			service: 'acl',
			url: `roles/operations/${roleId}`,
			body: {
				Operations: operations,
			},
		});
		dispatch(
			triggerNotification({
				type: response?.status === 200 ? 'success' : 'error',
				message: response?.data?.message ?? `Permission has removed`,
				autoClose: response?.status === 200 ? 100 : 500,
			})
		);
		dispatch(operationsList());
		// Events.publish(GRID_EVENTS.CLEAR_SELECTION, { tableId })

		return response;
	} catch (e) {
		dispatch(
			triggerNotification({
				type: 'error',
				autoClose: 500,
				message: e?.data?.message ?? `Unable to remove Permission, Please try again later.`,
			})
		);
		return e;
	}
};

export const handleRemovebulkAccess = async ({ payload: { tableId, ids } }) => {
	const dispatch = getDispatch();
	try {
		const { data } = await postAPIDataV3({
			service: 'acl',
			url: `aclGrid/row`,
			body: {
				tableId,
				ids,
				// IsActive: false,
				appId: 'theta-dev-staging',
			},
		});
		Events.publish(GRID_EVENTS.CLEAR_SELECTION, { tableId });
	} catch (e) {
		dispatch(
			triggerNotification({
				type: 'error',
				autoClose: 500,
				message: e?.data?.message ?? `Unable to delete Role, Please try again later.`,
			})
		);
		return e;
	}
};

export default function* rootSaga() {
	return [
		yield takeLatest(triggerCreateRole, handleCreateRole),
		yield takeLatest(triggerToggleRoleState, handleToggleRoleState),
		yield takeLatest(triggerAddOperation, handleAddOperation),
		yield takeLatest(triggerRemoveOperation, handleRemoveOperation),
		yield takeLatest(triggeRemovebulkAccess, handleRemovebulkAccess),
	];
}
